/**
 *  shopListセクションの店舗リストアニメーションjs
 */

import mixitup from 'mixitup';
import Swiper from 'swiper';

const shopListCtrl = () => {
  if ($('.mix-container').length) {
    /**
     * MixitUp3 を初期化
     * https://github.com/patrickkunka/mixitup/tree/v3
     */
    const shoplistMix = mixitup('.mix-container', {
      selectors: {
        target: '[data-mix="mix"]',
        control: '[data-mix="controll"]',
      },
      animation: {
        animateResizeContainer: true,
        clampHeight: true,
        duration: 400,
        effectsIn: 'fade translateY(-20px)',
        effectsOut: 'fade translateY(20px)',
        nudge: false,
        reverseOut: true,
      },
      load: { // 最初に表示する条件のクラス名を指定
        // filter: '.area-0',
        filter: 'none',
      },
    });

    // リストが表示されたら説明表示を隠す
    const $atention = $('.shop-list-attention');
    $('.mix-container').on('mixClick', (e) => {
      if (!$atention.hasClass('invisible')) {
        $atention.addClass('invisible');
        $(e.currentTarget).off('mixClick');
      }
    });

    /**
     * swiper を初期化
     * http://idangero.us/swiper/
     */
    const slide = new Swiper('.swiper-container', {
      pagination: '.swiper-pagination',
      slidesPerView: 11,
      centeredSlides: false,
      spaceBetween: 5,
      grabCursor: true,
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
      freeMode: true,
      breakpoints: {
        1200: {
          slidesPerView: 8,
        },
        992: {
          slidesPerView: 6,
        },
        768: {
          slidesPerView: 5,
        },
        576: {
          slidesPerView: 3,
        },
      },
    });
  }
};

export default shopListCtrl;



// WEBPACK FOOTER //
// ./src/scripts/common/shopListCtrl.js